export default [
    {
        path: 'relatorio-paciente-conecta-cidadao',
        component: () => import(
            /* webpackChunkName: 'cadastro-relatorio-paciente-conecta-cidadao' */
            '@/views/cadastro/relatorio-paciente-conecta-cidadao/Index'
        ),
        redirect: 'relatorio-paciente-conecta-cidadao/index',
        children: [
            {
                name: 'cadastro-relatorio-paciente-conecta-cidadao-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'cadastro-relatorio-paciente-conecta-cidadao' */
                    '@/views/cadastro/relatorio-paciente-conecta-cidadao/List.vue'
                ),
            },
        ],
    },
]
